module.exports = __webpack_public_path__ + "media/images/arrow-ba4921146c99ab74427b6b496d007a7b.svg";